// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1831":"bd904a5c","9367":"b536a0f1"}[chunkId] || chunkId) + "." + {"1831":"a4ea4123f78dff55","5121":"32350e3c22b6d270","9367":"051031222c3679fa"}[chunkId] + ".js";
};